import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwFilterTileRendererBaseComponent} from '@devwareapps/devware-cap';

@DwComponent({
   key: 'manage-users-filter-tile-renderer',
  name: 'Manage Users Filter Tile Renderer',
  isGlobal: true,
  componentType: DwComponentType.filterTileRenderer
})

@Component({
  selector: 'app-manage-users-filter-tiles',
  templateUrl: './manage-users-filter-tiles.component.html',
  styleUrls: ['./manage-users-filter-tiles.component.scss']
})
export class ManageUsersFilterTilesComponent extends DwFilterTileRendererBaseComponent implements OnInit {

  ngOnInit(): void {
  }

}
